module.exports = __webpack_public_path__ + "static/img/6.526b564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/6.png
// module id = 69p3
// module chunks = 1